// extracted by mini-css-extract-plugin
export default {"cancelbutton":"cancelbutton_cancelbutton__x-t5d"};